import RegionFieldComponent, {
  RegionFieldProps,
} from 'components/forms/fields/region-field/region-field.component';
import React from 'react';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useAddressFieldNames, useMapsAddress } from '../../address-form.hooks';

export type RegionFieldProps2 = {
  name: string;
  'data-testid'?: string;
} & RegionFieldProps;

const RegionField = ({
  name,
  'data-testid': dataTestId = 'RegionField',
  ...rest
}: RegionFieldProps2) => {
  const { t } = useTranslation();
  useMapsAddress(name, 'region');
  const { country: countryName } = useAddressFieldNames();
  const countryValue = useWatch({ name: countryName });

  return (
    <RegionFieldComponent
      country={countryValue}
      name={name}
      data-testid={dataTestId}
      label={t('forms.fields.region.label')}
      {...rest}
    />
  );
};

export default React.memo(RegionField);
